import {create} from 'zustand';
import {UseSelectedDoctorStoreProps} from './types';

export const useSelectedDoctorStore = create<UseSelectedDoctorStoreProps>(set => ({
	doctor: null,
	setDoctor: doctor => set({doctor}),
	reset: () => set({doctor: null}),
}));
